import { withStyles } from "@material-ui/core";
import React from "react";
import appConstants from "../../../../../appConstants";
import { DateTimeEditor } from '@dataGrid/components/cellEditors';
import { formatDateTime } from '@dataGrid/gridUtilities';

const styles = (theme) => ({
  IBCutoffInputContainer: {
    borderRight: `1px solid ${theme.AppBGColor}`,
    display: "flex",
    marginRight: 10,
    paddingBottom: 4,
    paddingRight: 10,
  },
  label: {
    marginRight: 16,
    paddingTop: 8,
    color: theme.HeaderSelectedText,
    fontWeight: 600,
    fontSize: 14,
  },
});
const IBETACutoffInput = ({ classes, onIBCutoffChanged, ibEtaCutOff }) => {
  const formattedIBCutoffDate = ibEtaCutOff
    ? formatDateTime(
        { value: ibEtaCutOff },
        appConstants.DATETYPES.DATETIME.format
      )
    : null;
  return (
    <div className={classes.IBCutoffInputContainer}>
      <span className={classes.label}>IB ETA Cut-off:</span>
      <DateTimeEditor
        dateType={appConstants.DATETYPES.DATETIME}
        onChange={onIBCutoffChanged}
        value={formattedIBCutoffDate}
        disableFocusInput
        isClearable={false}
        openTo="hours"
      />
    </div>
  );
};

export default withStyles(styles)(IBETACutoffInput);
